import React, { useMemo, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Container, Card, Button, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import { CardBody } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle, faSort, faInfoCircle, faEyeSlash, faFileAlt, faEye } from '@fortawesome/free-solid-svg-icons'
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../allocatedsurveydata/TableContainer"
import { useSelector } from "react-redux";
import { selectExternalUserTasks } from './externalUserTasksSlice';
import { FileUploads } from "../allocatedsurveydata/FileUploads";
import HomePageBanner from '../homepage-banner/banner';
import { listAdminUserData } from '../homepage-banner/adminListSlice';
import { useDispatch } from 'react-redux';
import { listTemplates, selectTemplates, clearTemplates } from '../downloadtemplate/listTemplatesSlice'

export const ExternalUserTasks = () => {

  const allsurveys = useSelector(selectExternalUserTasks);
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch();
  const org_id = location.state?.cso_id;
  const templates = useSelector(selectTemplates);
  const company_name = location.state?.company_name

  useEffect(() => {
    dispatch(clearTemplates());
    dispatch(listAdminUserData(org_id))
  }, [])

  useEffect(() => {
    if (allsurveys && allsurveys.length > 0) {
      fetchTemplates();
    }
  }, [allsurveys]);

  function byKeyStartDate(arr, key) {
    const keySK = key.SK
    for (var i = 0, L = arr.length; i < L; i++) {
      if (arr[i].SK === keySK) {
        if (arr[i].PINStartDate) {
          return arr[i].PINStartDate
        } else {
          return key.survey_start_date
        }
      }
    }
  }

  function byKeyEndDate(arr, key) {
    const keySK = key.SK
    for (var i = 0, L = arr.length; i < L; i++) {
      if (arr[i].SK === keySK) {
        if (arr[i].PINEndDate) {
          return arr[i].PINEndDate
        } else {
          return key.survey_end_date
        }
      }
    }
  }

  function dateFormat(longDate) {
    if (longDate && longDate !== "" && longDate !== " ") {
      const unixStamp = Date.parse(longDate);
      const newDate = new Date(unixStamp)
      const dateString = newDate.getDate().toString() +
        "/" + (newDate.getMonth() + 1).toString() +
        "/" + newDate.getFullYear().toString()
      return dateString;
    } else return null;
  }

  function byKeyPK(arr, key) {
    for (var i = 0, L = arr.length; i < L; i++) {
      if (arr[i].survey_id === key) {
        return arr[i].PK;
      }
    }
  }

  const fetchTemplates = () => {
    if (allsurveys && allsurveys.length > 0) {
      allsurveys.map((surveyRow) => {
        dispatch(listTemplates(byKeyPK(allsurveys, surveyRow.PK)));
      });
    }
  };

  const renderRowSubComponent = row => {
    const uploads = allsurveys.filter(obj => {
      return (obj.SK === row.original.id) && obj.fileUploads && obj.fileUploads.length > 0
    })

    return (
      uploads.length === 0 ? (
        <div style={{ margin: "0 auto", textAlign: "center" }}> No file upload data available </div>
      ) : (
        <Card>
          <CardBody>
            <FileUploads uploads={uploads[0].fileUploads} />
          </CardBody>
        </Card>
      )
    )
  }

  let allSurveys = []
  if (allsurveys && allsurveys.length > 0) {
    allsurveys.map((surveyRow) => {
      return allSurveys.push({
        id: surveyRow.PK,
        title: surveyRow.author_title,
        start_date: dateFormat(byKeyStartDate(allsurveys, surveyRow)),
        end_date: dateFormat(byKeyEndDate(allsurveys, surveyRow)),
        download: surveyRow.SK.slice(7),
        upload: surveyRow.survey_id
      })
    })
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Survey Title',
        accessor: 'title',
        disableFilters: true,
        disableSortBy: true
      },
      {
        disableFilters: true,
        disableSortBy: false,
        Header: () => (
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 300 }}
            overlay={(
              <Popover id="popover-basic">
                Sort surveys by start date
              </Popover>
            )} >
            <div>
              Start Date <FontAwesomeIcon icon={faSort} />
            </div>
          </OverlayTrigger>
        ),
        sortable: true,
        resizable: false,
        accessor: 'start_date',
        Cell: props => (
          <div style={{ textAlign: "left" }}>
            {props.value}
          </div>
        )
      },
      {
        disableFilters: true,
        disableSortBy: false,
        Header: () => (
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 300 }}
            overlay={(
              <Popover id="popover-basic">
                Sort surveys by end date
              </Popover>
            )} >
            <div>
              End Date <FontAwesomeIcon icon={faSort} />
            </div>
          </OverlayTrigger>
        ),
        sortable: true,
        resizable: false,
        accessor: 'end_date',
        Cell: props => (
          <div style={{ textAlign: "left" }}>
            {props.value}
          </div>
        )
      },
      {
        Header: () => (
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 300 }}
            overlay={<Popover id="popover-basic">Use this button to download templates required to fill out the survey.</Popover>}
          >
            <div>Download Template <FontAwesomeIcon icon={faQuestionCircle} /></div>
          </OverlayTrigger>
        ),
        accessor: 'download',
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ value }) => {
          const hasTemplate = templates.some(templateFile => templateFile.Key && templateFile.Key.includes(value));
          return (
            <div style={{ textAlign: "center" }}>
              {hasTemplate ? (
                <Link to={`/home/download/${value}`}>
                  <Button variant="warning">Download Template</Button>
                </Link>
              ) : (
                <Button
                  disabled
                  style={{
                    cursor: "not-allowed",
                    color: "rgba(0, 0, 0, 0.65)",
                    borderColor: "grey",
                    backgroundColor: "#d3d3d3",
                    opacity: 1,
                  }}
                >
                  Not Applicable
                </Button>
              )}
            </div>
          );
        },
      },
      {
        disableFilters: true,
        disableSortBy: true,
        Header: () => (
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 300 }}
            overlay={(
              <Popover id="popover-basic">
                Use this button to upload files.
              </Popover>
            )} >
            <div>
              Upload Files <FontAwesomeIcon icon={faQuestionCircle} />
            </div>
          </OverlayTrigger>
        ),
        sortable: false,
        resizable: false,
        accessor: 'upload',
        Cell: props => (
          <div style={{ textAlign: "center" }}>
            <Link to={{ pathname: `/home/upload/${props.value}`, state: { org_id: org_id } }}>
              <Button variant="secondary">Upload File</Button>
            </Link>
          </div>
        )
      },
      {
        Header: () => (
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 300 }}
            overlay={(
              <Popover id="popover-basic">
                View details of previously uploaded files.
              </Popover>
            )} >
            <div style={{ textAlign: "center" }}>
              <FontAwesomeIcon icon={faFileAlt} />
            </div>
          </OverlayTrigger>
        ),
        id: 'expander',
        Cell: ({ row }) => (
          <div style={{ textAlign: "center" }}>
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded
                ? <FontAwesomeIcon icon={faEyeSlash} title="Toggle Row Expanded" />
                : <FontAwesomeIcon icon={faEye} title="Toggle Row Hidden" />}
            </span>
          </div>
        )
      }
    ],
    [org_id, templates]
  )

  return (
    <Col style={{ paddingLeft: 50, paddingRight: 50 }}>
      <Container fluid className='pt-5'>
        <HomePageBanner />
        <Card>
          <Card.Header style={{ backgroundColor: "#1D345C", color: "white" }}>
            <h3 style={{ textAlign: 'left', float: 'left' }}>Available Tasks: <b>{company_name}; {org_id}</b>&nbsp;</h3>
            <OverlayTrigger
              placement="top"
              delay={{ show: 150, hide: 300 }}
              overlay={(
                <Popover id="popover-basic">
                  Once a file has been uploaded it may take a few minutes for the tables to update.
                </Popover>
              )} >
              <h5 style={{ textAlign: 'right', float: 'right' }}><FontAwesomeIcon icon={faInfoCircle} /></h5>
            </OverlayTrigger>
          </Card.Header>
          <Card.Body>
            <TableContainer columns={columns} data={allSurveys} renderRowSubComponent={renderRowSubComponent} />
          </Card.Body>
        </Card>
        <div style={{ paddingTop: '10px', float: 'right' }}>
        <Button onClick={() => history.goBack()} variant='info'>
          Back to Home
        </Button>
      </div>
      </Container>
    </Col>
  );
};

export default ExternalUserTasks;